import { Select, ItemHeader } from '@/components/Style/Common'
import type { RegularIncome } from '@/types/AddIncome'

import type { PropertyDispatch } from './Behaviour/PropertyDispatch'
import { Property } from './Behaviour/PropertyDispatch'
import EmployedIncomeInput from './EmployedIncomeInput'
import SelfEmployedIncomeInput from './SelfEmployedIncomeInput'

interface Props {
  income: RegularIncome
  propertyDispatch: PropertyDispatch
}

export const STATUS_OPTIONS = [
  { label: 'Employed', value: 'employment' },
  { label: 'Self-Employed', value: 'self-employed' },
]

const RegularIncomeInput: React.FC<Props> = ({ income, propertyDispatch }) => {
  return (
    <div>
      <ItemHeader>What is the employment status?</ItemHeader>
      <Select
        value={income.status}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          propertyDispatch.set(Property.Status, e.target.value)
        }
      >
        {STATUS_OPTIONS.map(({ label, value }, i) => (
          <option key={i} value={value}>
            {label}
          </option>
        ))}
      </Select>
      {
        // eslint-disable-next-line eqeqeq
        income.status == 'employment' && (
          <EmployedIncomeInput income={income} propertyDispatch={propertyDispatch} />
        )
      }
      {
        // eslint-disable-next-line eqeqeq
        income.status == 'self-employed' && (
          <SelfEmployedIncomeInput income={income} propertyDispatch={propertyDispatch} />
        )
      }
    </div>
  )
}

export default RegularIncomeInput
